export const StatCard = ({ label, value, hint, icon: Icon, tone = "light", testId }) => {
  const dark = tone === "dark";
  return (
    <div
      data-testid={testId}
      className={`relative overflow-hidden rounded-2xl border p-5 transition-transform duration-300 hover:-translate-y-0.5 ${
        dark ? "border-blue-900 bg-[#0B192C] text-white" : "border-blue-100 bg-white"
      }`}
    >
      <div className="flex items-start justify-between gap-3">
        <p className={`text-xs font-bold uppercase tracking-widest ${dark ? "text-blue-300" : "text-slate-500"}`}>{label}</p>
        {Icon && (
          <span className={`rounded-lg p-2 ${dark ? "bg-blue-500/20 text-amber-400" : "bg-blue-50 text-blue-700"}`}>
            <Icon className="h-4 w-4" />
          </span>
        )}
      </div>
      <p className={`mt-3 font-mono-num text-2xl font-semibold ${dark ? "text-white" : "text-slate-900"}`}>{value}</p>
      {hint && <p className={`mt-1 text-xs ${dark ? "text-blue-200" : "text-slate-500"}`}>{hint}</p>}
    </div>
  );
};
